<ng-container *ngIf="(isLanding$ | async) && !(loading$ | async)">
  <am-header-landing></am-header-landing>
</ng-container>
<div class="results mb-grid-container-full mb-grid-row'">
  <ng-container *ngIf="(viewMap$ | async) === false; else viewMapTemplate">
    <am-user-inactivity *ngIf="(hotels$ | async) && (hotels$ | async).length && viewInit"
      [hotel]="(hotels$ | async)[0]">

    </am-user-inactivity>


    <div class="results__breadcrumbs mb-grid-col-12-dt mb-grid-row" *ngIf="!isExpert">
      <mb-breadcrumbs class="mb-grid-col-12-dt">
        <a mb-breadcrumb-item href="/">Home</a>
        <a mb-breadcrumb-item href="/hoteles" i18n="@@hotel__accommodations"> Alojamientos</a>
        <a mb-breadcrumb-item> {{ ((loading$ | async) && '...') || (entity$ | async)?.name }}</a>
      </mb-breadcrumbs>
    </div>


    <div class="results__content mb-grid-col-12-dt mb-grid-row">
      <div class="mb-grid-col-3-dt sidebar">
        <div class="results__content__header__title">
          <h1>
            <span *ngIf="showHotelsIn$ | async" i18n="@@hotel__in">Hoteles en</span><span class="--capitalize">
              {{ ((loading$ | async) && '...') || (entity$ | async)?.name }}</span>
          </h1>
        </div>



        <ng-container *ngIf="(loading$ | async); else amFilters">
          <am-filters-list-skeleton></am-filters-list-skeleton>
        </ng-container>


        <ng-template #amFilters>
          <ng-container *ngIf="(disneySearch || universalSearch)">
            <am-benefits-banner [isDisney]="disneySearch" [isUniversal]="universalSearch"></am-benefits-banner>
          </ng-container>

          <ng-container *ngIf="!(context$ | async)?.isLanding">
            <am-view-map [imageStyle]="true"></am-view-map>
          </ng-container>

          <ng-container *ngIf="filters$ | async as filters">
            <am-filter-list *ngIf="filters" [filtersList]="filters?.list" [allFilterList]="listFilter"
              [appliedFilters]="filters?.applied" [isMobile]="false" [isArgentina]="isArgentina" 
              [isLanding]="hasSeo" [ngClass]="{ 'filters--seo': hasSeo }"></am-filter-list>
          </ng-container>
        </ng-template>

        <ng-container *ngIf="hasSeo && (hotels$ | async)?.length > 0">
          <am-seo-search [destination]="seo.destination"></am-seo-search>
        </ng-container>
      </div>

      <div class="results__hotels-list mb-grid-col-9-dt mb-grid-col-12">
        <am-banner-benefit-disney
          *ngIf="showBannerDisney && disneySearch && (hotels$ | async)?.length > 0"></am-banner-benefit-disney>
        <ng-container *ngIf="isAlliance">
          <div class="results__hotels-list__header__alliances-slider am-slider-container">
            <am-alliances-slider></am-alliances-slider>
          </div>
        </ng-container>
        <div class="results__hotels-list__header__sorting">
          <div class="results__hotels-list__header__sorting__filters">
            <am-price-by *ngIf="!(isLanding$ | async)"
              [disabled]="(loading$ | async) || !(hotels$ | async)?.length"></am-price-by>

            <am-sorting-by [disabled]="(loading$ | async) || !(hotels$ | async)?.length"></am-sorting-by>

            <ng-container *ngIf="!(context$ | async)?.isLanding">
              <am-view-map></am-view-map>
            </ng-container>
          </div>

          <ng-container *ngIf="!(loading$ | async)">
            <div>
              <am-few-offer *ngIf="
                  occupancy >= 65 &&
                  (hotels$ | async)?.length &&
                  !(filters$ | async)?.applied?.length &&
                  !!!(customBanner$ | async)
                " [occupancy]="occupancy"></am-few-offer>
            </div>
          </ng-container>
        </div>
        <mb-alert class="results__alert" type="notification" *ngIf="
            (loading$ | async) !== true && (customBanner$ | async) && (hotels$ | async)?.length
          ">
          <mb-alert-description>{{ (customBanner$ | async)?.text }}</mb-alert-description>
        </mb-alert>
        <ng-container *ngIf="loading$ | async; else amHotels">
          <am-hotels-list-skeleton></am-hotels-list-skeleton>
        </ng-container>
        <ng-template #amHotels>
          <ng-container *ngIf="(hotels$ | async) && !!(hotels$ | async)?.length; else errorNoResults">
            <am-hotels-list [hotels]="hotels$ | async" class="ng-star-inserted mb-grid-container-full mb-grid-row">
              ></am-hotels-list>
            <am-paginator *ngIf="pagination$ | async as pagination" [pagination]="pagination"></am-paginator>

            <ng-container *ngIf="isLanding$ | async">
              <am-interlinking></am-interlinking>
            </ng-container>
          </ng-container>
          <ng-template #errorNoResults>
            <am-error-no-results [appliedFilters]="!!(filters$ | async)?.applied?.length" [error]="error$ | async"
              [locale]="(context$ | async)?.locale"></am-error-no-results>
          </ng-template>
        </ng-template>
      </div>
    </div>
  </ng-container>
  <ng-template #viewMapTemplate>
    <div class="results__view-map mb-grid-container-full mb-grid-row" [class.results__view-map--experts]="isExpert">
      <div class="results__view-map__container mb-grid-col-12 mb-grid-col-12-dt mb-grid-row">
        <div class="results__view-map__container__filters mb-grid-col-3-dt" *ngIf="!expandedMap">

          <ng-container *ngIf="(loading$ | async); else amFilters">
            <am-filters-list-skeleton></am-filters-list-skeleton>
          </ng-container>

          <ng-template #amFilters>
            <ng-container *ngIf="filters$ | async as filters">
              <am-filter-list *ngIf="filters && !expandedMap" [filtersList]="filters?.list"
                [appliedFilters]="filters?.applied" [isMobile]="false" [allFilterList]="listFilter" 
                [isArgentina]="isArgentina" section="mapa">
              </am-filter-list>
            </ng-container>
          </ng-template>

        </div>
        <div class="results__view-map__container__map mb-grid-col-9-dt">
          <div class="toggle-expand-map" (click)="toggleExpandedMap()">
            <mb-icon *ngIf="!expandedMap; else arrowRightIcon" icon="arrow-left"></mb-icon>
            <ng-template #arrowRightIcon>
              <mb-icon icon="arrow-right"></mb-icon>
            </ng-template>
          </div>
          <ng-template #noResults>
            <am-error-no-results [appliedFilters]="!!(filters$ | async)?.applied?.length" [error]="error$ | async"
              [locale]="(context$ | async)?.locale"></am-error-no-results>
          </ng-template>
          <ng-container *ngIf="!!(hotels$ | async)?.length; else noResults">
            <am-hotels-map></am-hotels-map>
          </ng-container>
        </div>
      </div>

    </div>
    <div (click)="(trackContactRowClick)">
      <!--am-experts-communications *ngIf="context$ | async as context" [channel]="context?.channel">
      </!--am-experts-communications-->
    </div>